import BaseRequest from './BaseRequest';

export default class ArtMarketplaceRequest extends BaseRequest {
  getList(nftContract) {
    const url = `/public/market-item/${nftContract}`;
    return this.get(url, {});
  }
}
